<template>
  <div class="margin5-top bg-white tipcontent">
    <div class="tipinfo"  v-if="showTips">
      <span class="title"><b></b>声明：</span>
      <span class="info"><div>本公司无第三方代收款账户，请认准小筑教育官方收款码！核实电话：010-57130711</div></span>
      <span class="close" @click="deleteinfo()"></span>
    </div>
    <div class="swiper-div padding15-0">
      <swiper
        class="bg-white imgBox row cen-center"
        ref="mySwiper"
        :options="swiperOptions"
      >
        <swiper-slide
          class=""
          v-for="(item, index) in swiperList"
          :key="index"
          @slideChange="slideChange"
        >
          <img @click="detailsList(index)" :src="item.url" alt />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showTips:this.getininfo(),
      swiperOptions: {
        slidesPerView: "auto",
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      },
      // swiperOptions: {
      //   slidesOffsetBefore: 10,
      //   slidesOffsetAfter:20,
      //   slidesPerView: 1.2,
      //   spaceBetween: 0,
      //   centeredSlides: true,
      //   centeredSlidesBounds: true,
      //   loop: true,

      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true
      //   }
      // }
    };
  },
  props: {
    swiperList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  mounted() {
    this.swiper.slideTo(2, 0, false);
  },
  methods: {
    slideChange() {},
    detailsList(index) {
      window.location.href = this.swiperList[index].plink;
    },
    deleteinfo(){
      document.cookie = 'xzjytipinfo=1';
      this.showTips=this.getininfo()
    },
    getininfo(){
      if(this.getCookie('xzjytipinfo')==1){
        return false;
      }else{
        return true;
      }
      
    },
    getCookie(name) {
      var reg = RegExp(name + '=([^;]+)');
      var arr = document.cookie.match(reg);
      if (arr) {
          return arr[1];
      } else {
          return '';
      }
    },
  },
};
</script>
<style lang="less" scoped>
// .swiper-div{
//   margin-top: 3/20rem;
//   height: 148/20rem;
// }
// .swiper-container {
//   width: 100%;
//   height: 100%;
// }
.tipcontent {
  position: relative;
  .tipinfo {
    width: 100%;
    height: 32/20rem;
    top: 0px;
    top: -5px;
    left: 0px;
    z-index: 999;
    position: absolute;
    background: linear-gradient(270deg, #fff5ea 0%, #feeed5 100%);
    display: flex;
    align-items: center;
    .title {
      font-size: 12/20rem;
      background: #fffaf2;
      line-height: 18/20rem;
      padding: 0 0 0 10/20rem;
      color: #f08041;
      height: 18/20rem;
      border-radius: 9/20rem;
      margin-left: 15/20rem;
      b {
        background: url(../assets/imgs/tip2x.png) center center no-repeat;
        display: inline-block;
        width: 13/20rem;
        height: 12/20rem;
        background-size: contain;
        vertical-align: middle;
        position: relative;
        top: -1px;
      }
    }
    .info {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      div {
        font-size:10/20rem;
        color:#333;
        width: 100%;
        animation: 15s scrolltext linear infinite;
      }
    }

    @keyframes scrolltext {
      0% {
        transform: translateX(130%);
      }

      100% {
        transform: translateX(-130%);
      }
    }
    .close {
      background: url(../assets/imgs/delete2x.png) center center no-repeat;
      width: 10/20rem;
      height: 10/20rem;
      margin: 0 15/20rem;
    }
  }
}
.imgBox {
  height: 118/20rem;
  border-radius: 5px;
  img {
    height: 100%;
    border-radius: 5px;
  }
  .swiper-slide {
    width: 88%;
    height: 105/20rem;
    border-radius: 5px;
    // width:80%;
    text-align: center;
    font-size: 18px;
    background: #fff;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition: 300ms;
    // transform: scale(0.9);
    padding: 0 0.2rem;
    margin-top: 0.35rem;
  }
  .swiper-slide-active,
  .swiper-slide-duplicate-active {
    // transform: scale(1);
    height: 118/20rem;
    margin-top: 0rem;
  }
}
</style>
